import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useRef } from "react";
import { useLinkAccountingSoftwareMutation } from "../api/queries";
import PageLoading from "./PageLoading";

const QuickBooksRedirect = () => {
  const hasRun = useRef(false);
  const navigate = useNavigate();
  const linkAccountingSoftwareMutation = useLinkAccountingSoftwareMutation();
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");
  const state = searchParams.get("state");
  const realmId = searchParams.get("realmId");
  const error = searchParams.get("error");

  useEffect(() => {
    // Prevent the useEffect from running twice in dev due to StrictMode
    if (hasRun.current) return;
    hasRun.current = true;

    if (error) {
      console.error("Error linking accounting software", error);
      navigate("/files-integrations");
      return;
    }

    const linkAndRedirect = async () => {
      try {
        await linkAccountingSoftwareMutation.mutateAsync({
          code: code ?? "",
          state: state ?? "",
          realmId: realmId ?? "",
          name: "QuickBooks",
        });
      } catch (error) {
        console.error("Error linking accounting software", error);
      }
      navigate("/files-integrations");
    };
    linkAndRedirect();
    // P.S. Due to StrictMode, this component will unmount and remount.
    // Don't abort the in-flight mutation on unmount; it causes cancellations in StrictMode.
    return () => {};
  }, [
    code,
    error,
    linkAccountingSoftwareMutation,
    navigate,
    realmId,
    state,
  ]);

  return <PageLoading />;
};

export default QuickBooksRedirect;
